import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { getCurrentUserTypes } from 'shared/api-endpoint-types';
import { getCurrentUser, login, logout, signup } from './apiEndpoints';

@Injectable({ providedIn: 'root' })
export class AuthService {
	private _currentUser: getCurrentUserTypes.Result | null = null;
	private _initialized = false;

	public constructor(private readonly router: Router) {}

	public get isLoggedIn(): boolean {
		return this._currentUser !== null;
	}

	public get currentUser(): getCurrentUserTypes.Result | null {
		return this._currentUser;
	}

	public get initialized(): boolean {
		return this._initialized;
	}

	public async checkSession(): Promise<boolean> {
		try {
			this._currentUser = await getCurrentUser(undefined);
			this._initialized = true;
			return true;
		} catch {
			this._currentUser = null;
			this._initialized = true;
			return false;
		}
	}

	public async login(username: string, password: string): Promise<getCurrentUserTypes.Result> {
		const result = await login({ username, password });
		this._currentUser = result;
		return result;
	}

	public async signup(username: string, password: string): Promise<getCurrentUserTypes.Result> {
		const result = await signup({ username, password });
		this._currentUser = result;
		return result;
	}

	public async logout(): Promise<void> {
		await logout(undefined);
		this._currentUser = null;
		void this.router.navigate(['/login']);
	}
}
